
import { createContext } from 'react'

export const contractContext = createContext(null)
